import OInput from '../../../../UI/FormControls/OInput';
import TextArea from '../../../../UI/FormControls/TextArea';

import CheckBox from '../../../../UI/FormControls/CheckBox';

const Inputs = ({ formValue, setFormValue, idRn }) => {
  const handleChange = (item) => {
    if (typeof formValue[item.target.name] === 'boolean') {
      setFormValue((curr) => {
        return { ...curr, [item.target.name]: item.target.checked };
      });
    } else {
      setFormValue((curr) => {
        return { ...curr, [item.target.name]: item.target.value };
      });
    }
  };

  return (
    <div>
      {' '}
      <OInput
        label="Naziv"
        name="proveravanaStavka"
        value={formValue.proveravanaStavka}
        handleChange={handleChange}
        style={{ width: '100%' }}
      />
      <CheckBox
        style={{ height: '70px' }}
        label="Čekirano"
        handleChange={handleChange}
        checked={formValue.cekirano}
        name="cekirano"
      />
      <TextArea
        label="Napomena"
        rows="4"
        name="napomena"
        value={formValue.napomena}
        handleChange={handleChange}
        style={{ width: '100%', height: '100px' }}
      />
    </div>
  );
};

export default Inputs;
